import { azureBlobFSMetadata } from 'app/registries/linked-service/azure-blob-fs-metadata';
import { IDynamicLinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { CommonResourceKind as ResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';
import { format } from 'app/shared/utils/string.util';
import { ConnectionAuthKind } from 'shell-models-lib';

export const oneLakeFileMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata = await azureBlobFSMetadata(injector);
    return {
        ...metadata,
        supportedAuthKindsInTrident: [ConnectionAuthKind.OAuth2, ConnectionAuthKind.ServicePrincipal],
        disabled: !GlobalVariables.enableOneLakeFileConnector,
        type: adfModelTypeMap.oneLakeFile.linkedServiceType,
        displayName: format(
            stringResources.ModelName_DisplayTextPreviewTemplate,
            stringResources.OneLakeFileLinkedService_DisplayText
        ),
        icon: {
            className: 'svg-i-100x100-OneLake'
        },
        copySourceTypes: [],
        copySinkTypes: [],
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'OneLakeFile' as ResourceKind
        },
        category: ['Workspace'],
        // Paths are relative to the connection's workspace/item; OneLake has no file system segment.
        locationPattern: {
            folderPath: '([^]*)/[^/]*',
            fileName: '(?:[^]*/)?([^/]*)'
        },
        locationPropertiesRequireParameters: ['folderPath', 'fileName'],
        containerLabel: undefined,
        containerLabelPlural: undefined,
        pathRegex: undefined,
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        supportDatasetV2: true,
        linkedServiceNamePrefix: 'OneLakeFiles',
        supportFirstClassParameterExperience: false,
        supportPE: false,
        controls: [],
        supportGetMetadataActivity: true,
        supportStoredProcedureActivity: false,
        supportScriptActivity: false,
        supportAutoFillCopilotInput: false
    };
};
